<template>
    <div>
        <CommonPopupFrame :changeHeight="82" :changeBottom="0" :isOpen="isOpenCustomerSupport" :closeCompleteAction="closeCustomerSupport">
            <div @click="closeCustomerSupport" style="padding-left: 12px; padding-top: 15px; font-size: 700; color: #808080; font-weight: 700; padding-bottom: 15px;">닫기</div>
            <div @touchmove.stop="() => {}" style="padding-top: 16px; overflow-y: scroll; flex: 1;">
                <RecommendReplyList :selectContents="selectSupport" :directInput="directInput" :titleStyle="titleStyle" :clickContents="setSelectSupport" :recommendReplyList="recommendReplyList" :title="title" :subTitle="subTitle"></RecommendReplyList>
            </div>
            <div style="height: 93px; padding: 0 12px;">
                <div @click="requestSupport" class="common_btn" :class="selectSupport === '' ? 'un_active' : 'active'" style="">요청하기</div>
            </div>
        </CommonPopupFrame>
        <CommonPopupFrame :isOpen="isOpenDirectInput" :closeCompleteAction="closeDirectInput" :changeHeight="50" :changeBottom="0">
            <div @click="closeDirectInput" style="padding-left: 12px; padding-top: 15px; font-size: 700; color: #808080; font-weight: 700; padding-bottom: 15px;">닫기</div>
            <div @touchmove.stop="() => {}" style="flex: 1; padding: 0 12px;">
                <div style="text-align: center;font-weight: 500; margin-bottom: 20px;">고객지원 요청할 내용을 직접 입력하세요</div>
                <textarea v-model="directInputContents" placeholder="100자 이내로 작성할 수 있습니다." style="font-size: 14px; padding: 12px; outline: none; border: none; background-color: #f5f5f5; border-radius: 12px; width: 100%; height: 165px; line-height: 20px;"></textarea>
                <div @click="requestSupport" style="margin-top: 21px;" class="common_btn" :class="directInputContents.length === 0 ? 'un_active' : 'active'">요청하기</div>
            </div>
        </CommonPopupFrame>
    </div>
</template>

<script>
import CommonPopupFrame from '@/components/modal/my/CommonPopupFrame'
import RecommendReplyList from '@/components/common/RecommendReplyList'
import ResponseCode from '@/ResponseCode'

export default {
    name: 'CustomerSupport',
    components: {CommonPopupFrame, RecommendReplyList},
    props: {
        isOpenCustomerSupport: {
            type: Boolean,
            default: false
        },
        closeCustomerSupport: {
            type: Function,
            default: () => {}
        }
    },
    data() {
        return {
            title: '고객지원 요청하기',
            subTitle: `아래의 내용을 선택하거나<br>직접 자세한 내용을 입력해서 요청하시면<br>내용 확인 후 메시지를 통해 지원하겠습니다.`,
            recommendReplyList: [
                { contents: '결제 및 결제 취소 문의' },
                { contents: '신고 및 피드백 문의' },
                { contents: '서비스 및 기능 설명 문의' },
                { contents: '회원가입 및 탈퇴 문의' },
                { contents: '비즈니스 관련 문의' },
            ],
            titleStyle: {
                fontSize: '32px',
                marginBottom: '8px',
            },
            selectSupport: '',
            isOpenDirectInput: false,
            directInputContents: ''
        }
    },
    methods: {
        setSelectSupport(support) {
            this.selectSupport = support
        },
        directInput() {
            this.isOpenDirectInput = true
            this.selectSupport = ''
        },
        closeDirectInput() {
            this.isOpenDirectInput = false
            this.directInputContents = ''
        },
        async requestSupport() {
            if (this.selectSupport === '' && this.directInputContents === '') {
                this.$GlobalStore.showAlert('요청할 내용을 선택하세요.')
                return
            }

            if (this.directInputContents.length >= 100) {
                this.$GlobalStore.showAlert('100자 이내로 작성해주세요.')
                return
            }
            this.$GlobalStore.showProgress()
            const formData = new FormData()
            formData.append('contents', this.directInputContents === '' ? this.selectSupport : this.directInputContents)

            const res = await this.$Axios.post('/api/support/request/save', formData)

            if (res.data.code === ResponseCode.SUCCESS) {
                this.closeDirectInput()
                this.closeCustomerSupport()
                this.$GlobalStore.showToastVer2('고객지원을 요청했습니다.')
                this.selectSupport = ''
                this.directInputContents = ''
                this.$GlobalStore.hideProgress()
            } else {
                this.$GlobalStore.showAlert(res.data.msg)
                this.$GlobalStore.hideProgress()
            }
        }
    },
    created() {
        this.requestSupport = this.$Once(this.requestSupport)
    }
}
</script>

<style scoped>
.common_btn {
    margin-top: 12px;
    text-align: center;
    line-height: 48px;
    height: 48px;
    border-radius: 12px;
    font-weight: 500;
    font-size: 14px;
}

.active {
    background-color: #210f03;
    color: #fff;
}

.un_active {
    background-color: #f5f5f5;
    color: #d9d9d9;
}

textarea::placeholder {
    font-size: 14px;
    columns: #bbbbbb;
}
</style>